import { createAction, props } from '@ngrx/store';
import {
  GameHistorySearchParams,
  MatchDetailsResultsForUserResponse,
} from '@fantaz/shared/data-access/models';

export const loadGameHistoryDetail = createAction(
  '[GameHistoryDetails Page] Init',
  props<{ params: GameHistorySearchParams }>(),
);

export const loadGameHistoryDetailsSuccess = createAction(
  '[GameHistoryDetails/API] Load GameHistoryDetails Success',
  props<{ gameHistoryDetails: MatchDetailsResultsForUserResponse }>(),
);

export const loadGameHistoryDetailsFailure = createAction(
  '[GameHistoryDetails/API] Load GameHistoryDetails Failure',
  props<{ error: any }>(),
);

export const clearGameHistoryDetails = createAction(
  '[GameHistoryDetails/API] Clear GameHistoryDetails',
);
